import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PartnerMerchantsService } from 'src/app/contexts/merchants/merchants.service';
import { Observable, forkJoin, lastValueFrom, throwError } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MerchantsGeneralService } from 'src/app/contexts/merchants/merchants-general.service';

@Component({
    selector: 'app-info-data-bank',
    templateUrl: './info-data-bank-modal.component.html',
    styleUrls: ['./info-data-bank-modal.component.scss'],
})
export class InfoDataBankModalComponent implements OnInit {
    model: any = {};
    form_bank_data: FormGroup;
    filteredBank: Observable<any[]>;
    bankToHighlight: string = '';

    constructor(
        private dialogRef: MatDialogRef<InfoDataBankModalComponent>,
        private fb: FormBuilder,
        private merchantService: MerchantsGeneralService,
        private toastr: ToastrService,
        private location: Location,
        private router: Router,
        private translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) { }

    ngOnInit() {

        this.location.replaceState(this.router.url + "#bank-account");

        this.model.partner = this.data.partner;
        this.model.account = this.data.account;
        this.model.merchant = this.data.merchant;
        this.model.user = this.data.user;

        this.buildForm();

        const apis = forkJoin([
            this.merchantService.listBanks(this.model.partner, this.model.account, this.model.merchant.external_id),
            this.merchantService.listPaymentsConditions(this.model.partner, this.model.account, this.model.merchant.external_id),
        ])
            .pipe(
                map(result => {

                    return {
                        banks: result[0],
                        paymentsConditions: result[1],
                    };
                }),
                catchError((erro) => throwError(erro))
            ).subscribe({

                next: (response) => {



                    this.filteredBank = this.form_bank_data.get('bank_accounts')?.get('bank_code')?.valueChanges
                        .pipe(
                            startWith(''),
                            map(bank => this.filterBank(bank))
                        );

                    this.model.banks = response.banks;
                    this.model.paymentsConditions = response.paymentsConditions;

                },
                complete: () => {
                    this.verifyInfoDataBank();
                }
            });

    }


    filterBank(name: string) {
        this.bankToHighlight = name;
        return this.model.banks?.filter(bank =>
            `${bank.code} - ${bank.name}`.toLowerCase().includes(name.toLowerCase()));
    }


    verifyInfoDataBank() {
        if (this.model.merchant?.bank_accounts) {
            if (this.model.merchant.bank_accounts?.length > 0)
                this.setForm();
        }
    }

    buildForm() {
        this.form_bank_data = this.fb.group({
            external_id: this.model.merchant?.external_id,
            bank_accounts: this.fb.group({
                external_id: [''],
                account_type: [Validators.required],
                agency: ['', [Validators.required, Validators.maxLength(4)]],
                number: ['', [Validators.required, Validators.maxLength(20)]],
                bank_code: ['', [Validators.required, Validators.maxLength(10)]]
            }),
        });
    }

    setForm() {

        this.form_bank_data.patchValue(this.model.merchant);
        if (this.model.merchant.bank_accounts)
            this.form_bank_data.get('bank_accounts')?.patchValue(this.model.merchant.bank_accounts[0]);

    }

    submit() {

        if (this.form_bank_data.valid) {

            this.model.merchant.pix_key_type = '6';

            var banks = [];
            var errors = [];

            var account_type = this.form_bank_data.get('bank_accounts').get('account_type').value;
            var bank_code = this.form_bank_data.get('bank_accounts').get('bank_code').value;
            var agency = this.form_bank_data.get('bank_accounts').get('agency').value;
            var number = this.form_bank_data.get('bank_accounts').get('number').value;

            banks.push({
                external_id: '',
                document_type: this.model.merchant.document_type,
                document: this.model.merchant.document,
                account_type: account_type,
                agency: agency,
                number: number,
                bank_code: bank_code
            });

            if ((account_type || bank_code) && (!agency || !number)) {

                this.inputValidators();
                errors.push(1);

            }
            else {

                this.removeAllValidatorBank();
            }

            if (errors.length > 0) {
                this.toastr.error(this.translate.instant('merchants.edit.bank_data_error'));
            }
            else {
                this.model.merchant.bank_accounts = banks;
                this.model.merchant.pix_key_type = '6';
                this.register(this.model.merchant);
            }
        }
    }

    displayBankName(bankCode) {
        const bank = this.model.banks?.find(b => b.bank_code === bankCode);
        return bank ? `${bank.bank_code} - ${bank.name}` : '';
    }

    removeAllValidatorBank() {

        this.form_bank_data.get('bank_accounts').get('account_type').clearValidators();
        this.form_bank_data.get('bank_accounts').get('agency').clearValidators();
        this.form_bank_data.get('bank_accounts').get('number').clearValidators();
        this.form_bank_data.get('bank_accounts').get('bank_code').clearValidators();


        this.updateValidator();
    }

    inputValidators() {
        this.form_bank_data.get('bank_accounts').get('account_type').setValidators([Validators.required]);
        this.form_bank_data.get('bank_accounts').get('agency').get('agency').setValidators([Validators.required]);
        this.form_bank_data.get('bank_accounts').get('number').get('number').setValidators([Validators.required]);
        this.form_bank_data.get('bank_accounts').get('bank_code').get('bank_code').setValidators([Validators.required]);
    }


    register(merchant) {
        if (this.model.user.portal == 'merchant') {
            this.merchantService.register(this.model.partner, this.model.account, this.model.merchant.external_id, merchant).subscribe(
                response => {
                    if (response.code === 1) {
                        this.toastr.success(this.translate.instant('merchants.modal.infoDataBank.success'));
                        this.close();
                    } else {
                        this.toastr.error(response.message.message);
                    }
                }
            );
        } {
            if (this.model.user.portal == 'console') {
                this.merchantService.register(this.model.partner, this.model.account, this.model.merchant.external_id, merchant).subscribe(
                    response => {
                        if (response.code === 1) {
                            this.toastr.success(this.translate.instant('merchants.modal.infoDataBank.success'));
                            this.close();
                        } else {
                            this.toastr.error(response.message.message);
                        }
                    }
                );
            }
        }
    }

    updateValidator() {
        this.form_bank_data.get('bank_accounts').get('account_type').updateValueAndValidity();
        this.form_bank_data.get('bank_accounts').get('agency').updateValueAndValidity();
        this.form_bank_data.get('bank_accounts').get('number').updateValueAndValidity();
        this.form_bank_data.get('bank_accounts').get('bank_code').updateValueAndValidity();
    }


    close() {
        this.dialogRef.close(this.model.merchant);
    }

}
